import { z } from 'zod';
import { PlatformEnum } from './platform';
import { MeetingReportSchema } from './summarize-meeting-result';
import { RosterSchema } from './roster';
import { StepsStatusSchema } from './status';
import { TranscriptSchema } from './transcript';

export const RecordingDTOSchema = z.object({
  id: z.string(),
  platform: PlatformEnum,
  meetingId: z.string(),
  meetingUrl: z.string(),
  tenantId: z.string(),
  submittedBy: z.string(),
  name: z.string().optional(),
  startTime: z.number().optional(),
  endTime: z.number().optional(),
  roster: RosterSchema,
  transcript: TranscriptSchema.optional(),
  report: MeetingReportSchema.optional(),
  status: StepsStatusSchema,
  userContext: z.string().optional(),
  audioExpired: z.boolean(),
  audioExpiredAt: z.string().datetime().optional(),
  transcriptExpired: z.boolean(),
  transcriptExpiredAt: z.string().datetime().optional(),
});

export type RecordingDTO = z.infer<typeof RecordingDTOSchema>;

